import { makeObservable, observable } from 'mobx';

import { assignModel } from '@/common/helpers/assignModel';
import { DriveItemPreview } from '@/drive/entities/DriveItem/DriveItemPreview';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { DriveFolderOutline } from '@/drive/entities/DriveNode';
import { getDriveFolderUrl } from '@/drive/utils/getDriveFolderUrl';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { ProjectDataAccess } from '@/security/types/DataAccess';

import { BaseDriveItem, DriveItemType } from './DriveItem.types';
import { SpectrumItem } from './SpectrumItem';

export class FolderItemModel {
  id!: DriveItemId;
  title!: string;
  type!: DriveItemType.Folder;
  description?: string;
  preview?: Nullable<DriveItemPreview>;
  canEdit!: boolean;
  canManageAccess!: boolean;
  count!: number;
  createdAt?: string;
  access!: GlobalAccessLevel;
  dataAccess!: ProjectDataAccess;
}

export class FolderItem extends BaseDriveItem {
  count!: number;

  access!: GlobalAccessLevel;

  dataAccess!: ProjectDataAccess;

  constructor(model: FolderItemModel) {
    super();

    makeObservable(this, {
      count: observable,
      access: observable,
      dataAccess: observable,
    });

    assignModel<FolderItemModel>(this as unknown as FolderItemModel, model);
  }

  getLinkData() {
    return {
      isExternal: false,
      url: getDriveFolderUrl(this.id),
    };
  }

  override isContainer() {
    return true;
  }

  override canChangePreview(): boolean {
    return true;
  }

  // spectrumItem is used in another driveType, where folder is not used
  override canContainItem(item: BaseDriveItem) {
    return !(item instanceof SpectrumItem);
  }

  toNode(): DriveFolderOutline {
    return {
      id: this.id,
      type: DriveItemType.Folder,
      title: this.title,
      count: this.count,
      description: this.description,
      access: this.access,
      dataAccess: this.dataAccess,
      canEdit: this.canEdit,
      canManageAccess: this.canManageAccess,
      children: [],
    };
  }
}
